export interface MetricsSummary {
  redesignsByStatus: Record<string, number>;
  totalRedesigns: number;
}

export async function fetchMetrics(): Promise<MetricsSummary> {
  const response = await fetch('/metrics');
  const text = await response.text();
  return parsePrometheusMetrics(text);
}

function parsePrometheusMetrics(text: string): MetricsSummary {
  const redesignsByStatus: Record<string, number> = {};
  let totalRedesigns = 0;

  for (const line of text.split('\n')) {
    if (line.startsWith('#') || !line.trim()) continue;

    const redesignMatch = line.match(/ui_orchestrator_redesigns_total\{status="([^"]+)"\}\s+(\d+)/);
    if (redesignMatch) {
      const count = parseInt(redesignMatch[2], 10);
      redesignsByStatus[redesignMatch[1]] = count;
      totalRedesigns += count;
    }
  }

  return { redesignsByStatus, totalRedesigns };
}
